document.addEventListener('DOMContentLoaded', function () {
  var STORAGE_KEY = 'defyne_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(handles) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
  }

  function isSaved(handle) {
    return getWishlist().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    var list = getWishlist();
    var index = list.indexOf(handle);
    if (index === -1) {
      list.push(handle);
    } else {
      list.splice(index, 1);
    }
    saveWishlist(list);
    return list.indexOf(handle) !== -1;
  }

  function syncButtonState(btn) {
    var handle = btn.getAttribute('data-product-handle');
    var active = isSaved(handle);
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    var label = btn.querySelector('.defyne-wishlist-btn__label');
    if (label) {
      label.textContent = active ? 'Saved to Wishlist' : 'Add to Wishlist';
    }
  }

  function syncAllButtons() {
    document.querySelectorAll('[data-defyne-wishlist-toggle]').forEach(syncButtonState);
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-defyne-wishlist-toggle]');
    if (!btn) return;
    event.preventDefault();
    var handle = btn.getAttribute('data-product-handle');
    toggle(handle);
    syncAllButtons();
  });

  syncAllButtons();

  // Render the wishlist page grid, if present
  var grid = document.getElementById('defyne-wishlist-grid');
  if (!grid) return;

  var handles = getWishlist();
  var emptyState = document.getElementById('defyne-wishlist-empty');

  if (handles.length === 0) {
    if (emptyState) emptyState.style.display = 'block';
    return;
  }

  if (emptyState) emptyState.style.display = 'none';

  handles.forEach(function (handle) {
    fetch('/products/' + handle + '.js')
      .then(function (res) {
        if (!res.ok) throw new Error('not found');
        return res.json();
      })
      .then(function (product) {
        var card = document.createElement('div');
        card.className = 'defyne-wishlist-card';
        var image = product.featured_image ? product.featured_image : (product.images[0] || '');
        var price = (product.price / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        card.innerHTML =
          '<a href="/products/' + product.handle + '" class="defyne-wishlist-card__link">' +
          (image ? '<img src="' + image + '&width=400" alt="' + product.title.replace(/"/g, '&quot;') + '" loading="lazy" width="400" height="500" class="defyne-wishlist-card__image">' : '') +
          '<span class="defyne-wishlist-card__title">' + product.title + '</span>' +
          '<span class="defyne-wishlist-card__price">' + price + '</span>' +
          '</a>' +
          '<button type="button" class="defyne-wishlist-card__remove" data-defyne-wishlist-toggle data-product-handle="' + product.handle + '">Remove</button>';
        grid.appendChild(card);
      })
      .catch(function () {
        // product may have been deleted/unpublished since being saved; skip silently
      });
  });

  grid.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-defyne-wishlist-toggle]');
    if (!btn) return;
    var card = btn.closest('.defyne-wishlist-card');
    setTimeout(function () {
      if (card) card.remove();
      if (getWishlist().length === 0 && emptyState) emptyState.style.display = 'block';
    }, 0);
  });
});
